import { render, staticRenderFns } from "./SavingDetail.vue?vue&type=template&id=b764ab84&scoped=true&"
import script from "./SavingDetail.vue?vue&type=script&lang=js&"
export * from "./SavingDetail.vue?vue&type=script&lang=js&"
import style0 from "./SavingDetail.vue?vue&type=style&index=0&id=b764ab84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b764ab84",
  null
  
)

export default component.exports